//言語切替処理
function sendUrllocation(locations){
    var url = location.href;
    switch (locations) {
      case 'jp':
        var result = url.replace('https://amarclifestore.com/en', 'https://amarclifestore.com');
        window.location.href = result;
        break;
      case 'en':
        var result = url.replace('https://amarclifestore.com', 'https://amarclifestore.com/en');
        window.location.href = result;
        break;
    }
}